import { useEffect, useState } from 'react';
import { NodeRunInstance } from '../../types/workflow';

const LOCAL_STORAGE_KEY_SELECTED_TEST_RUN_INSTANCE = 'selectedTestRunInstanceId';

interface TestRunInput {
    run_instance: {
        id: string;
    };
    node_run_instances: NodeRunInstance[];
}

interface UseSelectedRunInstanceProps {
    nodeId: string | undefined;
    testRunInputs: TestRunInput[] | undefined;
    updateNodeConfigsFromRunInstances: (nodeId: string, response_config: string) => void;
}

const useSelectedTestRunInstance = ({
    nodeId,
    testRunInputs,
    updateNodeConfigsFromRunInstances,
}: UseSelectedRunInstanceProps) => {
    const [selectedRunInstanceId, _setSelectedRunInstanceId] = useState('');

    const setSelectedRunInstanceId = (runInstanceId: string) => {
        if (nodeId && runInstanceId) {
            localStorage.setItem(LOCAL_STORAGE_KEY_SELECTED_TEST_RUN_INSTANCE, `${nodeId}:${runInstanceId}`);
        }
        _setSelectedRunInstanceId(runInstanceId);

        const runInput = testRunInputs?.find(input => input.run_instance.id === runInstanceId);
        if (runInput && nodeId) {
            updateNodeConfigsFromRunInstances(
                nodeId,
                runInput.node_run_instances[0]?.flat_map || '',
            );
        }
    };

    useEffect(() => {
        if (!testRunInputs?.length || !nodeId || selectedRunInstanceId) return;

        const savedRunInstanceId = localStorage.getItem(LOCAL_STORAGE_KEY_SELECTED_TEST_RUN_INSTANCE);
        const [storedNodeId, storedInstanceId] = savedRunInstanceId?.split(':') || [];
        const savedRunInstance = savedRunInstanceId ? testRunInputs.find(input => input.run_instance.id === storedInstanceId) : null;

        if (storedNodeId === nodeId && savedRunInstance) {
            setSelectedRunInstanceId(savedRunInstance.run_instance.id);
        } else {
            setSelectedRunInstanceId(testRunInputs[0].run_instance.id);
        }
    }, [selectedRunInstanceId, testRunInputs, updateNodeConfigsFromRunInstances, nodeId]);
 
    return {
        selectedRunInstanceId,
        setSelectedRunInstanceId,
    };
};

export default useSelectedTestRunInstance; 